





















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Account } from '@/modules/admin/me';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component
export default class Menu extends Vue {
  private UserTypes = UserTypes;
  private FunctionTypes = FunctionTypes;
  private CollectionAgencyTypes = CollectionAgencyTypes;

  @Prop({ default: false }) private isCollapse: boolean;

  private defaultActive = '1';

  get user(): Account {
    return this.$store.state.me.user;
  }

  get userName(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName}　${this.user.firstName}`;
    }
  }

  get myPageTitle(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName} ${this.user.firstName} さんの情報`;
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  @Watch('userRole')
  private changeUserRole() {
    this.$nextTick(() => {
      this.setSelectRoute();
    });
  }

  @Watch('$route')
  private changeRoute() {
    this.setSelectRoute();
  }

  private mounted() {
    this.loadData();
  }

  private loadData() {
    this.setSelectRoute();
  }

  private setSelectRoute() {
    let selectName: string = '';
    if (!!this.$router.currentRoute.name) {
      const name = this.$router.currentRoute.name.toLowerCase();
      if (name.indexOf('top') === 0) {
        selectName = 'Top';
        this.defaultActive = '1';
      }
      if (name.indexOf('message') === 0 || name.indexOf('comment') === 0) {
        selectName = 'MessageList';
        this.defaultActive = '2';
      }
      if (name.indexOf('chat') === 0) {
        selectName = 'ChatList';
        this.defaultActive = '3';
      }
      if (name.indexOf('report') === 0) {
        selectName = 'ReportList';
        this.defaultActive = '4';
      }
      if (name.indexOf('record') === 0) {
        selectName = 'RecordList';
        this.defaultActive = '5';
      }
      if (name.indexOf('enterleave') === 0) {
        selectName = 'EnterLeaveList';
        this.defaultActive = '6';
      }

      if (name.indexOf('reservationcalendar') === 0) {
        selectName = 'ReservationCalendar';
        this.defaultActive = '8';
      } else if (name.indexOf('reservation') === 0) {
        selectName = 'Reservation';
        this.defaultActive = '7';
      }

      if (name.indexOf('student') === 0) {
        selectName = 'StudentList';
        this.defaultActive = '21';
      }
      if (name.indexOf('user') === 0) {
        selectName = 'UserList';
        this.defaultActive = '22';
      }
      if (name.indexOf('recordcontrol') === 0) {
        selectName = 'RecordControlList';
        this.defaultActive = '23';
      }
      if (name.indexOf('school') === 0
        || name.indexOf('gradeadvancesetting') === 0) {
        selectName = 'SchoolEdit';
        this.defaultActive = '24';
      }

      if (name.indexOf('schedule') === 0
        || name.indexOf('baseschedule') === 0
        || name.indexOf('reservablecount') === 0) {
        selectName = 'Schedule';
        this.defaultActive = '25';
      }

      if (name.indexOf('tag') === 0) {
        selectName = 'TagList';
        this.defaultActive = '26';
      }

      if (name.indexOf('billlist') === 0
        || name.indexOf('billdetail') === 0
        || name.indexOf('billcreate') === 0
        || name.indexOf('billedit') === 0) {
        selectName = 'BillList';
        this.defaultActive = '27-1';
      }
      if (name.indexOf('billdownload') === 0) {
        selectName = 'BillDownload';
        this.defaultActive = '27-2';
      }
      if (name.indexOf('periodicbilllist') === 0
        || name.indexOf('periodicbilldetail') === 0
        || name.indexOf('periodicbillcreate') === 0
        || name.indexOf('periodicbilledit') === 0) {
        selectName = 'PeriodicBillList';
        this.defaultActive = '27-3';
      }
      if (name.indexOf('billtemplatelist') === 0
        || name.indexOf('billtemplatecreate') === 0
        || name.indexOf('billtemplateedit') === 0) {
        selectName = 'BillTemplateList';
        this.defaultActive = '27-4';
      }
      if (name.indexOf('billitemssetting') === 0) {
        selectName = 'BillItemsSetting';
        this.defaultActive = '27-5';
      }
      if (name.indexOf('billsetting') === 0) {
        selectName = 'BillSetting';
        this.defaultActive = '27-6';
      }
      if (name.indexOf('creditcardsetting') === 0) {
        selectName = 'CreditcardSetting';
        this.defaultActive = '27-7';
      }

      if (name.indexOf('manual') === 0) {
        selectName = 'ManualList';
        this.defaultActive = '80';
      }
    }
    const parent = this.$refs.menu as Vue;
    parent.$children.forEach((group) => {
      group.$children.forEach((li) => {
        if (!!li.$props.route && !!li.$props.route.name) {
          if (li.$props.route.name === selectName) {
            li.$el.classList.add('is-active');
          } else {
            li.$el.classList.remove('is-active');
            (li.$el as HTMLElement).blur();
          }
        }
      });
    });
  }

  private operate(command: any) {
    this.$router.push(command);
    this.$emit('selectMenu');
  }

  private onSelectMenu() {
    this.$emit('selectMenu');
  }

  private onLinkSite(url: string) {
    window.open(url);
  }
}
